<script setup lang="ts">
// import { TypeTour } from '../types/general'; // error not provide an export named 'TypeTour'

interface TypeTour {
  title: string;
  icon: string;
  slug: string;
}

const props = defineProps<{ item: TypeTour }>();
const { title, icon, slug } = props.item;
</script>

<template>
  <NuxtLink :to="'/' + slug" class="flex flex-col items-center justify-center cursor-pointer group">
    <img :src="icon" class="w-8 h-8 group-hover:translate-y-1.5 translate-y-1" />
    <span class="text-white">{{ title }}</span>
    <svg width="61" height="5" viewBox="0 0 61 5" fill="none" class="group-hover:fill-primary"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 5C0.5 2.23858 2.73858 0 5.5 0H55.5C58.2614 0 60.5 2.23858 60.5 5H0.5Z" />
    </svg>
  </NuxtLink>
</template>

<style scoped>
.router-link-exact-active {
  svg {
    @apply fill-primary;
  }
}
</style>
